import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Rest from '../Generated/ReactUI';
import {BotImageControl} from "./BotImageControl";

export interface BotHeaderCardProps extends React.Props<BotHeaderCard> {
    initialBot: Rest.IBot;
    className?: string;
    initialCardLinks?: JSX.Element;
    transparentBackground?: boolean;
    defaultIconUrl: string;
}

export interface BotHeaderCardState {
    bot: Rest.IBot;
    cardLinks?: JSX.Element;
}

const leadingHash = new RegExp("^#*");

export class BotHeaderCard extends React.Component<BotHeaderCardProps, BotHeaderCardState> {
    constructor(props : BotHeaderCardProps) {
        super(props);

        this.state = {
            bot: this.props.initialBot,
            cardLinks: props.initialCardLinks
        };
    }

    private renderHashtags() {
        // replace all (including 0) leading '#' with a single '#'
        const hashText = this.state.bot.Hashtags.map(tag => tag.replace(leadingHash, "#")).join(', ');
        return hashText ? <li>{hashText}</li> : null;
    }

    public render(): JSX.Element {

        var className = "grid-card-base bot-card-hero " + (this.props.className || '');

        return (
            <div className={className}>
                <BotImageControl bot={this.state.bot} className="image-cell"
                    transparentBackground={this.props.transparentBackground}
                    defaultIconUrl={this.props.defaultIconUrl}/>
                <div className="bot-content">
                    <h3>{this.state.bot.Name}</h3>
                    <ul className="ul-vert-bar"><li className="publisher">{this.state.bot.Publisher}</li>{this.renderHashtags() }</ul>
                </div>
                <div className="card-links">{this.state.cardLinks}</div>
                {this.props.children}
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Views/BotHeaderCard.tsx